import BaseController from '../base_controller'

export default class extends BaseController {}
